<template>
  <div class="container">
    <loading-a v-if="!showImg"></loading-a>
    <div
      v-show="showImg"
      class="img-box"
      v-for="(item, index) in list"
      :key="index"
    >
      <img
        class="img"
        :src="require('@/assets/imgs/homePage/img-' + index + '.jpg')"
        @load="handleImgLoad"
      />
      <div class="btn-box">
        <div class="btn btn0" @click="toNewLink(item.url0)">Buy >></div>
        <div v-if="index === 0" class="btn btn1" @click="toLink(item.url1)">Learn more >></div>
        <div v-else-if="index === 3" class="btn btn1" @click="toLink(item.url1)">Learn more >></div>
        <div v-else class="btn btn1" @click="toLink(item.url1)">Learn more >></div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingA from '@/components/loadingA.vue'
export default {
  data () {
    return {
      list: [
        { url0: 'https://www.amazon.com/gp/product/B0CSYC9YZ3', url1: '#/detailsPage?name=Trochilus(Ritcher/Pop)' },
        { url0: 'https://www.amazon.com/dp/B0BV99WHDP', url1: '#/detailsPage?name=Assassin' },
        { url0: 'https://www.amazon.com/dp/B0BV9P9X3T', url1: '#/detailsPage?name=Ninja' },
        { url0: 'https://www.amazon.com/dp/B0BV6PFXG8', url1: '#/detailsPage?name=GM-0648' },
        { url0: 'https://www.amazon.com/gp/product/B0DDXX6XJN', url1: '#/detailsPage?name=Infinity' },
        { url0: 'https://www.amazon.com/dp/B0BVH7TYNY', url1: '#/detailsPage?name=Luna' }
      ],
      showImg: false
    }
  },
  components: { loadingA },
  watch: {},
  methods: {
    toNewLink (url) {
      window.open(url)
    },
    toLink (url) {
      window.location.href = url
    },
    handleImgLoad () {
      this.showImg = true
    }
  }
}
</script>
<style lang="scss" scoped>
@keyframes ani-background {
  0% {
    width: 50%;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
}
.container {
  .img-box {
    position: relative;
    .img {
      width: 100%;
      height: 100%;
      display: block;
    }
    .btn-box {
      font-size: 2rem;
      font-weight: 200;
      color: $main0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 40%;
      position: absolute;
      height: 52px;
      line-height: 52px;
      z-index: 1;
      .btn {
        position: relative;
        cursor: pointer;
        &::before {
          content: "";
          width: 52px;
          height: 52px;
          position: absolute;
          top: 0;
          left: -60px;
        }
        &:hover {
          &::after {
            content: "";
            width: 100%;
            height: 5px;
            position: absolute;
            bottom: -10px;
            left: 0;
            right: 0;
            margin: 0 auto;
            animation: ani-background 0.2s linear;
            background: linear-gradient(90deg, $main0 0%, $main1 100%);
          }
        }
        &.btn0 {
          &::before {
            background: url("../assets/imgs/homePage/icon-0.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        &.btn1 {
          &::before {
            background: url("../assets/imgs/homePage/icon-1.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    &:nth-child(1) {
      .btn-box {
        left: 32%;
        top: 30%;
      }
    }
    &:nth-child(2) {
      .btn-box {
        left: 40%;
        right: 0;
        margin: 0 auto;
        top: 60%;
      }
    }
    @media (max-width: 768px) {
      &:nth-child(2) {
        .btn-box {
          left: 50%;
        }
      }
    }
    &:nth-child(3) {
      .btn-box {
        left: 0;
        right: 0;
        margin: 0 auto;
        top: 30%;
      }
    }
    &:nth-child(4) {
      .btn-box {
        left: 10%;
        top: 58%;
      }
    }
    &:nth-child(5) {
      .btn-box {
        left: 32%;
        top: 36%;
      }
    }
    &:nth-child(6) {
      .btn-box {
        left: 32%;
        top: 36%;
      }
    }
    @media screen and (max-width: 767px) {
      .btn-box {
        font-size: 0.75rem;
        width: 50%;
        height: 20px;
        line-height: 20px;
        .btn {
          &::before {
            width: 20px;
            height: 20px;
            left: -30px;
          }
        }
      }
    }
    @media screen and (min-width: 768px) {
    }
    @media screen and (min-width: 992px) {
    }
    @media screen and (min-width: 1200px) {
    }
  }
}
</style>
